import { createSlice } from "@reduxjs/toolkit";
import type { CatalogPourbackReason } from "../../../models/CatalogPourbackReason";

const CatalogPourbackInitialState: {
  pourbackReasons: CatalogPourbackReason[] | null;
} = {
  pourbackReasons: null,
};

export const CatalogPourbackReducer = createSlice({
  name: "__",
  initialState: CatalogPourbackInitialState,
  reducers: {
    setPourbackReasons(state, { payload }) {
      state.pourbackReasons = payload;
    },
  },
});
